import React from 'react';

const ContentWrapper = ({children}) => {
    return  <div className="px-2 lg:px-32 2xl:px-56">
        {children}
    </div>
}

export default ContentWrapper;